await themeComponent(theme.components['mc-element'], false);

class McModal extends McElement {
  constructor() {
    super();
    this._onAnyClick = this._onAnyClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
  }

  connectedCallback() {
    // Basic ARIA; don’t overcomplicate
    this.setAttribute('role', this.getAttribute('role') || 'dialog');
    this.setAttribute('aria-modal', 'true');

    // Close on any click (backdrop or content)
    this.addEventListener('click', this._onAnyClick);

    // Close on ESC
    document.addEventListener('keydown', this._onKeydown);

    // If the modal is already active on DOM load, enforce body lock
    if (this.classList.contains('mc-active')) this.afterOpen();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onAnyClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  _onAnyClick(e) {
    // You said "close whenever one clicks" — so we don't stop propagation.
    // If you later want to exclude specific elements, add guards here.
    this.close();
  }

  _onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') this.close();
  }

  open() {
    if (!this.classList.contains('mc-active')) {
      this.classList.add('mc-active');
      this.afterOpen();
    }
  }

  close() {
    if (this.classList.contains('mc-active')) {
      this.classList.remove('mc-active');
      this.afterClose();
    }
  }

  // If your mc-btn with data-action="deactivate" calls a base-class method, keep compatibility:
  deactivate() { this.close(); }

  afterOpen = () => {
  document.body.classList.add('noscroll');

  // Lazy-load modal images
  const lazyImages = this.querySelectorAll('.zoom-img');

  lazyImages.forEach(img => {
    if (!img.src && img.dataset.src) {
      img.src = img.dataset.src;
    }

    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
    }

    if (img.dataset.sizes) {
      img.sizes = img.dataset.sizes;
    }

    img.dataset.loaded = "true"; // just in case you want to track it
  });
};

  afterClose = () => {
    document.body.classList.remove('noscroll');
  };
}

if (!window.customElements.get('mc-modal')) {
  window.customElements.define('mc-modal', McModal);
}
window.McModal = McModal;
